import { Injectable } from '@angular/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrientationService {
  orientationChangeSubject = new BehaviorSubject<void>(null);

  constructor() {
    this.initializeOrientationChange();
  }

  async lockOrientation(orientation: 'portrait' | 'landscape') {
    try {
      await ScreenOrientation.lock({ orientation });
    } catch (error) {
      console.error('Failed to lock screen orientation', error);
    }
  }

  async unlockOrientation() {
    try {
      await ScreenOrientation.unlock();
    } catch (error) {
      console.error('Failed to unlock screen orientation', error);
    }
  }

  initializeOrientationChange() {
    ScreenOrientation.addListener('screenOrientationChange', (event) => {
      console.log('Screen orientation changed', event);
      this.orientationChangeSubject.next();
    });
  }
}
